import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "pb-10 pb-lg-15" }, [
  /*#__PURE__*/_createVNode("h2", { class: "fw-bolder text-dark" }, "Account Info"),
  /*#__PURE__*/_createVNode("div", { class: "text-gray-400 fw-bold fs-6" }, [
    /*#__PURE__*/_createTextVNode(" If you need more info, please check out "),
    /*#__PURE__*/_createVNode("a", {
      href: "#",
      class: "link-primary fw-bolder"
    }, "Help Page"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)
const _hoisted_3 = { class: "mb-10 fv-row" }
const _hoisted_4 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center form-label mb-3" }, [
  /*#__PURE__*/_createTextVNode(" Specify Team Size "),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Provide your team size to help us setup your billing"
  })
], -1)
const _hoisted_5 = {
  class: "row mb-2",
  "data-kt-buttons": "true"
}
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "\n              btn btn-outline btn-outline-dashed btn-outline-default\n              w-100\n              p-4\n            " }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "fw-bolder fs-3" }, "1-1", -1)
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "\n              btn btn-outline btn-outline-dashed btn-outline-default\n              w-100\n              p-4\n              active\n            " }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "fw-bolder fs-3" }, "2-10", -1)
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "\n              btn btn-outline btn-outline-dashed btn-outline-default\n              w-100\n              p-4\n            " }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "fw-bolder fs-3" }, "10-50", -1)
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "\n              btn btn-outline btn-outline-dashed btn-outline-default\n              w-100\n              p-4\n            " }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "fw-bolder fs-3" }, "50+", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "form-text" }, " Customers will see this shortened version of your statement descriptor ", -1)
const _hoisted_19 = { class: "mb-10 fv-row" }
const _hoisted_20 = /*#__PURE__*/_createVNode("label", { class: "form-label mb-3" }, "Team Account Name", -1)
const _hoisted_21 = { class: "mb-0 fv-row" }
const _hoisted_22 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center form-label mb-5" }, [
  /*#__PURE__*/_createTextVNode(" Select Account Plan "),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Monthly billing will be based on your account plan"
  })
], -1)
const _hoisted_23 = { class: "mb-0" }
const _hoisted_24 = { class: "d-flex flex-stack mb-5 cursor-pointer" }
const _hoisted_25 = { class: "d-flex align-items-center me-2" }
const _hoisted_26 = { class: "symbol symbol-50px me-6" }
const _hoisted_27 = { class: "symbol-label" }
const _hoisted_28 = { class: "svg-icon svg-icon-1 svg-icon-gray-600" }
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createVNode("span", { class: "fw-bolder text-gray-800 text-hover-primary fs-5" }, "Company Account"),
  /*#__PURE__*/_createVNode("span", { class: "fs-6 fw-bold text-gray-400" }, "Use images to enhance your post flow")
], -1)
const _hoisted_30 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_31 = { class: "d-flex flex-stack mb-5 cursor-pointer" }
const _hoisted_32 = { class: "d-flex align-items-center me-2" }
const _hoisted_33 = { class: "symbol symbol-50px me-6" }
const _hoisted_34 = { class: "symbol-label" }
const _hoisted_35 = { class: "svg-icon svg-icon-1 svg-icon-gray-600" }
const _hoisted_36 = /*#__PURE__*/_createVNode("span", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createVNode("span", { class: "fw-bolder text-gray-800 text-hover-primary fs-5" }, "Developer Account"),
  /*#__PURE__*/_createVNode("span", { class: "fs-6 fw-bold text-gray-400" }, "Use images to your post time")
], -1)
const _hoisted_37 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_38 = { class: "d-flex flex-stack mb-0 cursor-pointer" }
const _hoisted_39 = { class: "d-flex align-items-center me-2" }
const _hoisted_40 = { class: "symbol symbol-50px me-6" }
const _hoisted_41 = { class: "symbol-label" }
const _hoisted_42 = { class: "svg-icon svg-icon-1 svg-icon-gray-600" }
const _hoisted_43 = /*#__PURE__*/_createVNode("span", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createVNode("span", { class: "fw-bolder text-gray-800 text-hover-primary fs-5" }, "Testing Account"),
  /*#__PURE__*/_createVNode("span", { class: "fs-6 fw-bold text-gray-400" }, "Use images to enhance time travel rivers")
], -1)
const _hoisted_44 = { class: "form-check form-check-custom form-check-solid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("label", _hoisted_7, [
            _createVNode(_component_Field, {
              type: "radio",
              class: "btn-check",
              name: "accountTeamSize",
              value: "1-1"
            }),
            _hoisted_8
          ])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode("label", _hoisted_10, [
            _createVNode(_component_Field, {
              type: "radio",
              class: "btn-check",
              name: "accountTeamSize",
              value: "2-10"
            }),
            _hoisted_11
          ])
        ]),
        _createVNode("div", _hoisted_12, [
          _createVNode("label", _hoisted_13, [
            _createVNode(_component_Field, {
              type: "radio",
              class: "btn-check",
              name: "accountTeamSize",
              value: "10-50"
            }),
            _hoisted_14
          ])
        ]),
        _createVNode("div", _hoisted_15, [
          _createVNode("label", _hoisted_16, [
            _createVNode(_component_Field, {
              type: "radio",
              class: "btn-check",
              name: "accountTeamSize",
              checked: "",
              value: "50+"
            }),
            _hoisted_17
          ])
        ])
      ]),
      _hoisted_18
    ]),
    _createVNode("div", _hoisted_19, [
      _hoisted_20,
      _createVNode(_component_Field, {
        type: "text",
        class: "form-control form-control-lg form-control-solid",
        name: "accountName",
        placeholder: "",
        value: ""
      }),
      _createVNode(_component_ErrorMessage, {
        name: "accountName",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ]),
    _createVNode("div", _hoisted_21, [
      _hoisted_22,
      _createVNode("div", _hoisted_23, [
        _createVNode("label", _hoisted_24, [
          _createVNode("span", _hoisted_25, [
            _createVNode("span", _hoisted_26, [
              _createVNode("span", _hoisted_27, [
                _createVNode("span", _hoisted_28, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/finance/fin001.svg" })
                ])
              ])
            ]),
            _hoisted_29
          ]),
          _createVNode("span", _hoisted_30, [
            _createVNode(_component_Field, {
              class: "form-check-input",
              type: "radio",
              name: "accountPlan",
              value: "1"
            })
          ])
        ]),
        _createVNode("label", _hoisted_31, [
          _createVNode("span", _hoisted_32, [
            _createVNode("span", _hoisted_33, [
              _createVNode("span", _hoisted_34, [
                _createVNode("span", _hoisted_35, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/graphs/gra006.svg" })
                ])
              ])
            ]),
            _hoisted_36
          ]),
          _createVNode("span", _hoisted_37, [
            _createVNode(_component_Field, {
              class: "form-check-input",
              type: "radio",
              checked: "",
              name: "accountPlan",
              value: "2"
            })
          ])
        ]),
        _createVNode("label", _hoisted_38, [
          _createVNode("span", _hoisted_39, [
            _createVNode("span", _hoisted_40, [
              _createVNode("span", _hoisted_41, [
                _createVNode("span", _hoisted_42, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/graphs/gra008.svg" })
                ])
              ])
            ]),
            _hoisted_43
          ]),
          _createVNode("span", _hoisted_44, [
            _createVNode(_component_Field, {
              class: "form-check-input",
              type: "radio",
              name: "accountPlan",
              value: "3"
            })
          ])
        ])
      ])
    ])
  ]))
}